import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withProps, withHandlers, withStateHandlers } from 'recompose'
import * as UserSelectors from 'app/modules/user/selectors'
import * as UserPropertiesSelectors from 'app/modules/user/properties/selectors'
import * as OrgSelectors from 'app/modules/org/selectors'
import * as UserActions from 'app/modules/user/actions'
import { patchOperations } from 'utils/PatchHelper'
import withTracking from 'components/hocs/withTracking'

// TODO: Lift into shared helper
import { AvailabilityStatus } from 'components/MainNav/NewAgentStatus/constants'

const isActiveAvailability = availability => (
  availability === AvailabilityStatus.ACTIVE ||
  availability === AvailabilityStatus.ON_CALL
)

const mapStateToProps = state => {
  const { limitNumChats, limitNumChatsEnabled } = OrgSelectors.properties(state)
  const currentUser = UserSelectors.currentUser(state)

  return {
    currentUser,
    isActive: isActiveAvailability(currentUser.availability),
    currentUserLoaded: UserSelectors.currentUserLoaded(state),
    limitNumChatsEnabled,
    limitNumChats,
    isUserAtConversationLimit: UserPropertiesSelectors.isUserAtConversationLimit(state),
  }
}

const mapDispatchToProps = dispatch => bindActionCreators(
  {
    updateCurrentUser: UserActions.updateCurrentUser,
  },
  dispatch,
)

export default compose(
  withTracking,
  connect(mapStateToProps, mapDispatchToProps),
  withStateHandlers(
    () => ({
      isUpdatingStatus: false,
      nextAvailability: null,
    }),
    {
      setNextAvailability: () => nextAvailability => ({
        isUpdatingStatus: true,
        nextAvailability,
      }),
      setNextAvailabilityDone: () => () => ({
        isUpdatingStatus: false,
        nextAvailability: null,
      }),
    },
  ),
  withHandlers({
    toggleStatus: (props) => ({ source }) => {
      if (props.isUpdatingStatus) {
        return
      }

      const nextAvailability = props.isActive
        ? AvailabilityStatus.AWAY
        : AvailabilityStatus.ACTIVE

      const operations = patchOperations(
        { availability: nextAvailability },
        { availability: props.currentUser.availability }
      )

      if (!operations.length) {
        return
      }

      props.setNextAvailability(nextAvailability)
      props.updateCurrentUser(operations)
        .finally(props.setNextAvailabilityDone)
      props.track('AgentStatusToggle clicked', {
        status: nextAvailability,
        source,
      })
    }
  }),
  withProps(({ isUpdatingStatus, isActive, nextAvailability }) => ({
    isActive: isUpdatingStatus
      ? isActiveAvailability(nextAvailability)
      : isActive
  })),
  withProps(({ currentUserLoaded }) => ({
    isAgentStatusLoaded: currentUserLoaded,
  })),
)



// WEBPACK FOOTER //
// ./src/scripts/components/withAgentStatus.js